<template>
  <div id="app" :class="{ 'is-mobile': isMobile }">
    <keep-alive>
     <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { initCookieProtocol } from './utils/cookie-protocal.js'

export default {
  name: 'app',
  data() {
    return {
      isMobile: false,
    };
  },
  mounted () {
    initCookieProtocol()
    const domain = this.getDomain()
    Cookies.set('i18next', 'en', {
      path: '/',
      expires: 30,
      domain: domain
    });
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (this.isMobile) {
      this.initViewport()
    }
  },
  methods: {
    getDomain () {
      const hostname = location.hostname
      // IP 直接返回hostname
      if (/((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))/.test(hostname)) {
        return hostname
      }
      let hostArr = hostname.split('.')
      return '.' + hostArr.slice(-2).join('.')
    },
    initViewport() {
      const width = 375
      const scale = window.innerWidth / width

      let meta = document.querySelector('meta[name=viewport]')
      let content = `width=${width}, initial-scale=${scale}, user-scalable=no`

      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute('name', 'viewport')
        document.head.appendChild(meta)
      }

      meta.setAttribute('content', content)
    },
  }
}
</script>

<style>
html, body{
  font-family: var(--font-family-Regular);
  line-height: normal;
}
@font-face {
  font-family: 'MonaSans-Bold';
  src: url('../src/assets/fonts/MonaSans-Bold.otf') format('opentype');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'MonaSans-Medium';
  src: url('../src/assets/fonts/MonaSans-Medium.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'MonaSans-Regular';
  src: url('../src/assets/fonts/MonaSans-Regular.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'MonaSans-SemiBold';
  src: url('../src/assets/fonts/MonaSans-SemiBold.otf') format('opentype');
  font-weight: 600;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/App.vue